// src/theme/components/iconButtonStyles.js
const iconButtonStyles = (theme) => ({
    MuiIconButton: {
      variants: [
        {
          props: { color: "primary" },
          style: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,

            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
      ],
  },
});

export default iconButtonStyles;
